export default __webpack_public_path__ + "static/media/MariaSneaker.7f629cef.jpg";